var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "bairun-container" },
    [
      _c(
        "div",
        { staticClass: "search-term" },
        [
          _c(
            "el-form",
            {
              staticClass: "demo-form-inline",
              attrs: { inline: true, model: _vm.searchInfo }
            },
            [
              _c(
                "el-form-item",
                { attrs: { label: "便利店" } },
                [
                  _c(
                    "el-select",
                    {
                      attrs: {
                        clearable: "",
                        filterable: "",
                        placeholder: "搜索条件"
                      },
                      model: {
                        value: _vm.searchInfo.sellerId,
                        callback: function($$v) {
                          _vm.$set(_vm.searchInfo, "sellerId", $$v)
                        },
                        expression: "searchInfo.sellerId"
                      }
                    },
                    _vm._l(_vm.sellerOptions, function(item) {
                      return _c("el-option", {
                        key: item.sellerId,
                        attrs: { label: item.sellerName, value: item.sellerId }
                      })
                    }),
                    1
                  )
                ],
                1
              ),
              _c(
                "el-form-item",
                { attrs: { label: "商品名称" } },
                [
                  _c("el-input", {
                    attrs: { placeholder: "搜索条件", clearable: "" },
                    on: { clear: _vm.onClearGoodsName },
                    model: {
                      value: _vm.searchInfo.goodsName,
                      callback: function($$v) {
                        _vm.$set(_vm.searchInfo, "goodsName", $$v)
                      },
                      expression: "searchInfo.goodsName"
                    }
                  })
                ],
                1
              ),
              _c(
                "el-form-item",
                { attrs: { label: "条形码" } },
                [
                  _c("el-input", {
                    attrs: { placeholder: "输入或扫码", clearable: "" },
                    model: {
                      value: _vm.searchInfo.goodsNo,
                      callback: function($$v) {
                        _vm.$set(_vm.searchInfo, "goodsNo", $$v)
                      },
                      expression: "searchInfo.goodsNo"
                    }
                  })
                ],
                1
              ),
              _c(
                "el-form-item",
                { attrs: { label: "入库批次号" } },
                [
                  _c("el-input", {
                    attrs: { placeholder: "搜索条件", clearable: "" },
                    model: {
                      value: _vm.searchInfo.goodsInNo,
                      callback: function($$v) {
                        _vm.$set(_vm.searchInfo, "goodsInNo", $$v)
                      },
                      expression: "searchInfo.goodsInNo"
                    }
                  })
                ],
                1
              ),
              _c(
                "el-form-item",
                { attrs: { label: "过期状态" } },
                [
                  _c(
                    "el-select",
                    {
                      attrs: { clearable: "", placeholder: "请选择" },
                      on: { change: _vm.onExpireStatusChange },
                      model: {
                        value: _vm.searchInfo.expireStatus,
                        callback: function($$v) {
                          _vm.$set(_vm.searchInfo, "expireStatus", $$v)
                        },
                        expression: "searchInfo.expireStatus"
                      }
                    },
                    [
                      _c("el-option", {
                        key: "1",
                        attrs: { label: "未过期", value: "1" }
                      }),
                      _c("el-option", {
                        key: "2",
                        attrs: { label: "已过期", value: "2" }
                      })
                    ],
                    1
                  )
                ],
                1
              ),
              _vm.searchInfo.expireStatus == 1
                ? _c(
                    "el-form-item",
                    { attrs: { label: "多少天后过期" } },
                    [
                      _c("el-input", {
                        attrs: {
                          placeholder: "",
                          clearable: "",
                          placeholder: "输入天数"
                        },
                        model: {
                          value: _vm.searchInfo.expireDays,
                          callback: function($$v) {
                            _vm.$set(_vm.searchInfo, "expireDays", $$v)
                          },
                          expression: "searchInfo.expireDays"
                        }
                      })
                    ],
                    1
                  )
                : _vm._e(),
              _c(
                "el-form-item",
                [
                  _c(
                    "el-button",
                    { attrs: { type: "primary" }, on: { click: _vm.onSubmit } },
                    [_vm._v("查询")]
                  )
                ],
                1
              ),
              _c(
                "el-form-item",
                [
                  _c("el-button", { on: { click: _vm.onReset } }, [
                    _vm._v("重置")
                  ])
                ],
                1
              )
            ],
            1
          )
        ],
        1
      ),
      _c(
        "el-table",
        {
          staticStyle: { width: "100%" },
          attrs: {
            data: _vm.tableData,
            border: "",
            stripe: "",
            "tooltip-effect": "dark"
          }
        },
        [
          _c("el-table-column", {
            attrs: { label: "便利店名称", prop: "sellerId", width: "200px" },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function(scope) {
                  return [
                    _vm._v(_vm._s(_vm._f("getSellerName")(scope.row.sellerId)))
                  ]
                }
              }
            ])
          }),
          _c("el-table-column", {
            attrs: { label: "供应商", prop: "supplierName", width: "200px" }
          }),
          _c("el-table-column", {
            attrs: { label: "商品名称", prop: "goodsName" }
          }),
          _c("el-table-column", {
            attrs: { label: "剩余库存", prop: "goodsStock" }
          }),
          _c("el-table-column", {
            attrs: { label: "成本单价", prop: "goodsCost" }
          }),
          _c("el-table-column", {
            attrs: { label: "成本金额", prop: "goodsAmount" }
          }),
          _c("el-table-column", {
            attrs: { label: "销售单价", prop: "goodsPrice" }
          }),
          _c("el-table-column", {
            attrs: { label: "条形码", prop: "goodsNo", width: "130px" }
          }),
          _c("el-table-column", {
            attrs: { label: "有效期开始", prop: "dateStart", width: "100px" },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function(scope) {
                  return [
                    _vm._v(_vm._s(_vm._f("formatDate")(scope.row.dateStart)))
                  ]
                }
              }
            ])
          }),
          _c("el-table-column", {
            attrs: { label: "有效期结束", prop: "dateEnd", width: "100px" },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function(scope) {
                  return [
                    _vm._v(_vm._s(_vm._f("formatDate")(scope.row.dateEnd)))
                  ]
                }
              }
            ])
          }),
          _c("el-table-column", { attrs: { label: "备注", prop: "remark" } }),
          _c("el-table-column", {
            attrs: { label: "入库批次号", prop: "goodsInNo", width: "150px" }
          }),
          _c("el-table-column", {
            attrs: { label: "入库时间", prop: "CreatedAt", width: "160px" },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function(scope) {
                  return [
                    _vm._v(
                      _vm._s(_vm._f("formatDateTime")(scope.row.CreatedAt))
                    )
                  ]
                }
              }
            ])
          })
        ],
        1
      ),
      _c("el-pagination", {
        style: { float: "right", padding: "20px" },
        attrs: {
          "current-page": _vm.page,
          "page-size": _vm.pageSize,
          "page-sizes": [10, 30, 50, 100],
          total: _vm.total,
          layout: "total, sizes, prev, pager, next, jumper"
        },
        on: {
          "current-change": _vm.handleCurrentChange,
          "size-change": _vm.handleSizeChange
        }
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }